/** DVA namespace — must match `model.js` and route registration. */
export const MODEL_NAME = 'shortenedUrls';

/** API route prefix — shared by `model.js` (createCrudModel) and list descriptor routes. */
export const FETCH_ROUTE = 'shortenedUrl';

/** Singular entity name for `createCrudModel` reducers/notifications. */
export const ENTITY_NAME = 'shortenedUrl';

/** i18n resource key for form drawer hero summary (`configForm.hero.summary.resource.{key}.*`). */
export const FORM_RESOURCE_KEY = 'shortenedUrls';

/** Default OData sort when the user clears column sorting. */
export const DEFAULT_ORDER_BY = 'created desc';
